import { useState,useEffect  } from 'react';
import './App.css';
import Navbar from './componets/Navbar';
import TextFrom from './componets/TextFrom';


function App() {

  const [appmode, setappmode] = useState(localStorage.getItem('appmode') || 'light');
  const toogleMode = () => {
    if (appmode === 'dark') {
      setappmode('light')
      showAlert("light mode has been enable!", "success")
    }
    else {
      setappmode('dark')
      showAlert("Dark mode has been enable!", "success")
    }
  }
  const [alert, setAlert] = useState(null)

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      Type: type
    })
    setTimeout(() => {
      setAlert(null)
    }, 5000);
  }

  useEffect(() => {
    localStorage.setItem('appmode', appmode);
  }, [appmode]);

  useEffect(() => {
    if (appmode === 'dark') {
      document.body.style.backgroundColor = '#000';
    } else {
      document.body.style.backgroundColor = 'white';
    }
  }, [appmode]);

  return (
    <div className={`gradient-background ${appmode}`}>
        <Navbar title="Convert Case" abouttext="About us" mode={appmode} toogleMode={toogleMode} alert={alert} setAlert={setAlert}></Navbar>
        <TextFrom mode={appmode} showAlert={showAlert} />
    </div>
  );
}

export default App;
